// Mobile parity: "What's your job search status?" radio list.
import { useState } from "react"
import { useOnboarding } from "../../contexts/OnboardingContext"
import { OnboardingStepShell, ContinueButton, RadioOption } from "./OnboardingStepShell"

const OPTIONS = [
  { id: "actively_looking", label: "Actively looking for a job" },
  { id: "open",             label: "Open to opportunities" },
  { id: "exploring",        label: "Just exploring" },
]

export default function JobSearchStatusStep({ onContinue, onBack, step, totalSteps }) {
  const { profile, updateField } = useOnboarding()
  const [selected, setSelected] = useState(profile?.jobSearchStatus || null)

  const pick = (id) => {
    setSelected(id)
    updateField({ jobSearchStatus: id })
  }

  return (
    <OnboardingStepShell
      title={"What's your\njob search status?"}
      step={step}
      totalSteps={totalSteps}
      onBack={onBack}
      bottom={<ContinueButton label="Continue" onClick={onContinue} disabled={!selected} />}
    >
      <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
        {OPTIONS.map((o) => (
          <RadioOption
            key={o.id}
            label={o.label}
            selected={selected === o.id}
            onClick={() => pick(o.id)}
          />
        ))}
      </div>
    </OnboardingStepShell>
  )
}
